import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="comprar" className="py-24 bg-gray-900 text-white relative overflow-hidden" data-id="element-173">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-500 via-amber-500 to-red-500" data-id="element-174"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-175">
        <div className="text-center mb-12" data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-177">
            No es un gasto. Es una herramienta.
          </h2>
          <div className="flex flex-wrap justify-center gap-4 text-gray-300 text-sm md:text-base" data-id="element-178">
            <span className="flex items-center gap-1" data-id="element-179">
              <Check className="w-4 h-4 text-green-400" data-id="element-180" /> Volver a leer
            </span>
            <span className="flex items-center gap-1" data-id="element-181">
              <Check className="w-4 h-4 text-green-400" data-id="element-182" /> Subrayar
            </span>
            <span className="flex items-center gap-1" data-id="element-183">
              <Check className="w-4 h-4 text-green-400" data-id="element-184" /> Retomar en otros
              momentos
            </span>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white text-gray-900 rounded-2xl shadow-2xl overflow-hidden max-w-lg mx-auto border-4 border-amber-400" data-id="element-185">
          {/* Header */}
          <div className="bg-amber-400 p-4 text-center" data-id="element-186">
            <p className="text-amber-900 font-bold uppercase tracking-wider text-sm" data-id="element-187">
              Oferta Especial Limitada
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-188">
            <h3 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-189">
              Pack Completo: Libro + 3 Bonos
            </h3>
            <p className="text-gray-500 text-sm mb-8" data-id="element-190">
              Acceso digital inmediato
            </p>

            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-191">
              <span className="text-2xl text-gray-400 line-through decoration-red-500 decoration-2" data-id="element-192">
                $49.990 ARS
              </span>
              <span className="text-5xl font-bold text-red-600" data-id="element-193">
                $19.990 ARS
              </span>
            </div>

            <div className="space-y-4 mb-10 text-left bg-gray-50 p-6 rounded-lg border border-gray-100" data-id="element-194">
              <div className="flex items-center gap-3" data-id="element-195">
                <Check className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-196" />
                <span className="font-medium" data-id="element-197">
                  Ebook "Esto no es una crisis"
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-198">
                <Check className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-199" />
                <span data-id="element-200">Bono 1: Guía de Reflexión Personal</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-201">
                <Check className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-202" />
                <span data-id="element-203">Bono 2: Diario de Claridad Emocional</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-204">
                <Check className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-205" />
                <span data-id="element-206">Bono 3: Cuando no sé qué hacer</span>
              </div>
            </div>

            <CTAButton text="Quiero empezar a leer ahora" subtext="Garantía de satisfacción • Pago seguro" className="w-full" data-id="element-207" />

            <div className="mt-6 flex items-center justify-center gap-2 text-xs text-gray-500" data-id="element-208">
              <Shield className="w-4 h-4" data-id="element-209" />
              <span data-id="element-210">100% digital — Acceso inmediato a tu correo</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}